import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

const growUp = keyframes`
  from{
    margin-bottom: 0;
    transform: scale(0);
  }

  to {
    transform: scale(1);
    margin-bottom: ${theme.spacing['2xl']};
  }
`

export const ErrorWrapper = styled.div`
  animation: ${growUp} 0.3s ease-out;
  margin-bottom: ${theme.spacing.lg};

  &.removeBigSpace {
    margin-top: -${theme.spacing.xm};
    margin-bottom: ${theme.spacing.sm};
  }
`

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;

  .forgetTitle {
    text-align: center;
    color: ${theme.colors.neutral.black};
    margin-bottom: ${theme.spacing.lg};
  }

  .forgetDescription {
    text-align: center;
    margin-bottom: ${theme.spacing.lg};
    padding: 0 ${theme.spacing.md};
  }

  .forgetDescriptionWithoutPad {
    text-align: center;
    margin-bottom: ${theme.spacing.lg};
    padding: 0 ${theme.spacing.xs};
  }

  .changedPasswordTitle {
    color: ${theme.colors.neutral.black};
    text-align: center;
    margin-bottom: ${theme.spacing.lg};
  }

  .changedPasswordDescription {
    text-align: center;
    margin-bottom: ${theme.spacing.sm};
  }

  .changedPasswordAlert {
    margin-bottom: ${theme.spacing.lg};
  }
`
export const ButtonWrapper = styled.div`
  margin-top: ${theme.spacing.lg};
`
export const LinkGoBackContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const LinkGoBack = styled.a`
  width: fit-content;
  color: ${theme.colors.primary.main};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  margin-top: ${theme.spacing.lg};

  display: flex;
  align-items: center;
`

export const ResendCode = styled.span`
  color: ${theme.colors.primary.main};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  text-decoration: underline;
  margin-top: ${theme.spacing.lg};
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
`

export const ValidateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${theme.spacing.lg} 0;

  @media (max-width: ${theme.breakpoints.xl}px) and (max-height: 890px) {
    margin: ${theme.spacing.sm} 0;
  }

  .validateTitle {
    margin-bottom: ${theme.spacing.xs};
    font-size: ${theme.typography.sizes.xs};

    @media (max-width: ${theme.breakpoints.xl}px) and (max-height: 890px) {
      font-size: ${theme.typography.sizes['2xs']};
    }
  }
  div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: ${theme.spacing.xs};
    font-size: ${theme.typography.sizes['2xs']};
  }

  span {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xs};
    &.rulePassed {
      color: ${theme.colors.alert.success.dark};
    }
  }
`
